import { createSignal } from "solid-js";

import { registerSW } from "virtual:pwa-register";

const [pendingUpdate, setPendingUpdate] =
  createSignal<() => void | Promise<void>>();

export { pendingUpdate };

if (import.meta.env.PROD) {
  let registration: ServiceWorkerRegistration | undefined;
  let reloading = false;

  const reloadForUpdate = () => {
    if (reloading) return;
    reloading = true;
    window.location.reload();
  };

  const checkForUpdates = () => {
    void registration?.update().catch(() => {
      // Ignore failed update checks.
    });
  };

  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      reloadForUpdate();
    });

    window.addEventListener("focus", checkForUpdates);
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") {
        checkForUpdates();
      }
    });
  }

  const updateSW = registerSW({
    onNeedRefresh() {
      const applyUpdate = async () => {
        await updateSW(true);
      };
      setPendingUpdate(() => applyUpdate);

      // Apply updates automatically so both web and desktop clients
      // do not remain stuck on stale bundles.
      void applyUpdate();
    },
    onOfflineReady() {
      console.info("Ready to work offline =)");
      // toast to users
    },
    onRegistered(r) {
      registration = r ?? undefined;

      // Check immediately on startup in case this client was left open
      // across a deployment and then brought back into focus.
      checkForUpdates();

      // Check for updates every 5 minutes while the app stays open.
      setInterval(checkForUpdates, 3e5);
    },
  });
}
